module.exports = __webpack_public_path__ + "static/media/Facebook.59b7071a.svg";